import VirApi from '../../../../services/api/virApi'

/* Service class used to perform api calls for dealing with ticket state updates */
class VirService {
    constructor() {
        this._api = VirApi.create();
    }

    api() {
        return this._api;
    }

     
    /**
     * Revert Permissions For Cancelled Ticket, so it is available in DIY
     * @param {any} viewModelId
     */
    async revertPermissionsForCancelledTicket(viewModelId, taxYear) {
        try {           
            var response = await this.api().revertPermissionsForCancelledTicket(viewModelId, taxYear);
            if (response && response.ok) {
                
                return response.data
            }
        } catch (ex) {
            console.log("failed to revert permissions for cancelled ticket", ex)
        }
        return null;
    }


}
const virService = new VirService();

export default virService;